import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useMyProfileUiStore = defineStore('myProfileUi', () => {
  const currentTab = ref<string>('personal-data')

  const shouldResetTab = ref(false)

  function resetTab() {
    currentTab.value = 'personal-data'
    shouldResetTab.value = true
  }

  function confirmReset() {
    shouldResetTab.value = false
  }

  return {
    currentTab,
    shouldResetTab,
    resetTab,
    confirmReset,
  }
})
